import React from "react"
import LoginForm from "./auth/login"


export default function Home() {
    return (
        <div className="diagonal-split-bg">
        <div className="container">
          <br />
          <br />
          <div className="row">
            <div className="col-sm-12 col-md-6">
              <h1>Product Carbon Calculator</h1>
              <h2 className="mt-5">
                <strong>
                  Streamlined embodied footprinting for products and assets
                </strong>
              </h2>
              <br />
              <p className="mt-3 text-muted">
                Welcome to the Product Carbon Calculator, your solution for
                assessing the embodied carbon footprint of products and assets.
                Designed as an accessible alternative for suppliers without
                Environmental Product Declarations (EPDs), this tool facilitates
                the straightforward calculation and dissemination of carbon
                footprint information.
              </p>
              <p className="text-muted">
                This user-friendly platform effectively caters to both suppliers
                and clients. Suppliers enjoy the advantage of using the tool at
                no charge to accurately measure and convey the carbon impact of
                their products and assets. At the same time, clients receive
                direct and organised access to their suppliers' embodied
                emissions data, which is crucial for integrating Scope 3 carbon
                footprint insights into their procurement decisions.
              </p>
              <p className="text-muted">
                While suppliers enjoy complimentary access, clients looking to
                integrate this tool into their procurement process can make
                sales enquiries at&nbsp;
                <a
                  href="mailto:max.lajtha@actionsustainability.com"
                  className="btn-link"
                >
                  max.lajtha@actionsustainability.com
                </a>
                . To see the Product Carbon Calculator in action, we encourage
                you to book a demo through
                <a
                  href="https://calendly.com/max-lajtha/introduction-to-the-sustainability-tool"
                  className="btn-link"
                >
                  &nbsp;this link
                </a>
              </p>
              <p className="text-muted">
                The Product Carbon Calculator is a dedicated module within the
                Sustainability Tool suite of measurement and performance
                management solutions.
              </p>

              <p className="text-muted">
                For further assistance or enquiries, our support team is ready
                to help at&nbsp;
                <a
                  className="btn-link"
                  href="mailto:info@sustainabilitytool.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  info@sustainabilitytool.com
                </a>
              </p>
            </div>
            <div className="col-sm-12 col-md-6">
              <LoginForm />
            </div>
          </div>
        </div>
      </div>
    )
}